import {CustomerManagementComponent} from './customer-management.component';
import {MasterManagementComponent} from "./master-management.component";
import {ProductManagementComponent} from "./product-management.component";
import {ReportManagementComponent} from "./report-management.component";
import {UserManagementComponent} from "./user-management.component";


export const ADMIN_COMPONENTS: any[] = [
    CustomerManagementComponent,
    MasterManagementComponent,
    ProductManagementComponent,
    ReportManagementComponent,
    UserManagementComponent
]

export * from "./customer-management.component";
export * from "./master-management.component";
export * from "./product-management.component";
export * from "./report-management.component";
export * from "./user-management.component";
